import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  pulse?: boolean;
  fullWidth?: boolean;
  variant?: 'primary' | 'outline';
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  pulse = true,
  fullWidth = true,
  variant = 'primary'
}: ButtonProps) {
  const primaryClasses = 'bg-gradient-to-b from-brand-greenLight to-brand-green hover:from-brand-green hover:to-brand-greenDark text-white border-b-4 border-brand-greenDark shadow-lg hover:shadow-xl hover:translate-y-[1px] active:translate-y-[3px] active:border-b-0';
  const outlineClasses = 'bg-white text-brand-green border-2 border-brand-green hover:bg-brand-greenSoft';
  const variantClasses = variant === 'primary' ? primaryClasses : outlineClasses;
  const baseClasses = 'btn-shine relative inline-flex items-center justify-center font-display font-bold transition-all duration-200 rounded-lg px-4 py-3 md:px-6 md:py-4 text-sm md:text-lg text-center uppercase tracking-wide cursor-pointer leading-tight';
  const pulseClasses = pulse ? 'animate-pulse-fast hover:animate-none' : '';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (!href) {
      scrollToCompra(e);
    }
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${variantClasses} ${pulseClasses} ${widthClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-40">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${variantClasses} ${pulseClasses} ${widthClasses} ${className}`} data-id="element-41">
      {children}
    </button>;
}